import moment from 'moment'

export default function () {
  return this.test('date', 'Esse campo deve ser uma data válida', function (value) {
    return typeof value === 'string'
      ? moment(value, 'DD/MM/YYYY', true).isValid()
      : true
  })
}
